const HASH_MARKER = '/#/';

/**
 * Parses partialAppUrl the same way as LoginController successHandler in
 * mimecast-web-components login-controller.js.
 */
export function resolveAppUrlFromPartialAppUrl(partialAppUrl: string): string {
  const hashIndex = partialAppUrl.indexOf(HASH_MARKER);

  if (hashIndex === -1) {
    return `${partialAppUrl}#/home`;
  }

  const path = partialAppUrl.slice(0, hashIndex);
  const hashTarget = `#/${partialAppUrl.slice(hashIndex + HASH_MARKER.length)}`;

  return `${path}${hashTarget}`;
}

/**
 * Returns the app root (everything before `/#/`), matching legacy
 * `partialAppRoot = self.currentLoginConf.partialAppUrl.split('/#/').shift()`.
 * Used by PostLoginRedirectService to build the `message`/`link` override targets,
 * which replace the default `#/home` hash rather than appending to it.
 */
export function resolveAppRoot(partialAppUrl: string): string {
  const hashIndex = partialAppUrl.indexOf(HASH_MARKER);

  return hashIndex === -1 ? partialAppUrl : partialAppUrl.slice(0, hashIndex);
}
